import type { PropsWithChildren } from 'react';
import { Navigate, useParams } from 'react-router-dom';
import authService from '../services/authService';
import { useAppDispatch } from '../hooks/useAppDispatch';

function MagicLinkRoute({ children }: PropsWithChildren): JSX.Element {
  const isLoggedIn = authService.isLoggedIn();
  const params = useParams<{ magicLinkId: string }>();
  const dispatch = useAppDispatch();
  authService.setDispatch(dispatch);

  if (!isLoggedIn && params.magicLinkId) {
    authService.loginMagicLink(params.magicLinkId);
  }

  return !authService.isLoggedIn() ? <>{children}</> : <Navigate to="/" />;
}

export { MagicLinkRoute };
